import { CSV_IMPORT } from 'routes/Support/components/ClientSupport/components/ClientConfiguration/ModuleForm/helpers/definitions';
import { useSelector } from 'store/hooks';
import { CSV_TABLES_V1 } from 'business/constants';
import { isKeyOf } from 'helpers/types/utils';
import { useUserHasRole } from 'hooks/user';
import { ADMIN, DECISION_USER } from 'business/constants';

const shouldShowFilesImportV1 = (client: ClientT): boolean =>
    isKeyOf(CSV_TABLES_V1, client.bind) &&
    CSV_TABLES_V1[client.bind].length > 0;

const useCanUserAccessFilesImport = (): boolean => {
    const isSupportUser = useSelector((state) => state.vision.isSupportUser);
    const isDecisionUser = useUserHasRole(DECISION_USER);
    const isAdminUser = useUserHasRole(ADMIN);
    return isSupportUser || isDecisionUser || isAdminUser;
};

/**
 * Check if the user should see the files import feature
 * It must be a support user or have the CSV_IMPORT feature enabled and be either a decision user or an admin user
 */
export const useShouldShowFilesImportV2 = (): boolean => {
    const isSupportUser = useSelector((state) => state.vision.isSupportUser);
    const { extraFeatures } = useSelector((state) => state.vision.client);
    const canUserAccessFilesImport = useCanUserAccessFilesImport();
    return (
        isSupportUser ||
        (extraFeatures.includes(CSV_IMPORT) && canUserAccessFilesImport)
    );
};

export const useShouldShowFilesImport = (): boolean => {
    const { client } = useSelector((state) => state.vision);
    const canUserAccessFilesImport = useCanUserAccessFilesImport();
    const hasAccessToV2 = useShouldShowFilesImportV2();
    const hasAccessToV1 = shouldShowFilesImportV1(client);
    return (hasAccessToV2 || hasAccessToV1) && canUserAccessFilesImport;
};
